<div #modal class="modal" role="dialog" tabindex="-1" appTranslate [ngClass]="options?.animation"
     [class.modal-center-content]="options?.centered" (click)="closeModalOnClick($event, modal)">
  <div class="modal-dialog modal-fullscreen-md-down" [class.modal-dialog-scrollable]="options?.scrollable !== false"
       [ngClass]="options?.cssClass" [style]="options?.style">
    <ng-template #container></ng-template>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="options?.backdrop"></div>
